import colors, { palette } from '../colors';
export default {
  primary: {
    container: {
      width: '100%',
      padding: '16px'
    },
    labelColor: {
      color: palette.primary
    },
    contentColor: {
      color: colors.darkBlue
    }
  },
  "default": {
    container: {
      width: '100%',
      padding: '16px'
    },
    labelColor: {
      color: colors.bluishGrey
    },
    contentColor: {
      color: colors.darkBlue
    }
  }
};